import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'register-account-type',
    templateUrl: './account-type.component.html',
    styleUrls: ['./account-type.component.css']
})

export class RegisterAccountTypeComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}